import { GET, GETNEW, POST, POSTNEW, EXPORTNEW,EXPORT,uploading, POSTFormData ,uploadingImg} from '@/request/http'
// 查询待处理审批列表
export const getMeWaitProcessApproval = p => POST('/approval/instances/me-wait-process', p)
// 查询已处理审批列表
export const getMeProcessApproval = p => POST('/approval/instances/me-processed', p)
// 查询抄送给我的审批列表
export const getCoypToMeApproval = p => POST('/approval/instances/carbon-copy-to-me', p)

//查询申请详情
export const getApprovalDetails = p => GET('/approval/instances/{instance_id}/detail', p)

//执行任务
export const approvalApply = p => POST('/approval/instancetask/execution', p)

//下载审核申请表
export const downloadApproval = p => GET('/approval/instances/{instance_id}/pdf', p, 1, 'get')

//获取查询待处理列表
export const getApprovalToWait = p => POSTNEW('/approval/instances/me-wait-process', p)

//获取查询已处理列表
export const getApprovalToFinish = p => POSTNEW('/approval/instances/me-processed', p)

//获取查询我发起的列表
export const getApprovalToSubmit = p => POSTNEW('/approval/instances/me-submit', p)

//获取查询抄送我的列表
export const getApprovalToCcme = p => POSTNEW('/approval/instances/carbon-copy-to-me', p)

//查询审批实例详情
export const getToDoDetail = p => GETNEW('/approval/instances/detail', p, 4)

//查询审批实例详情通过审批编号
export const getToDoDetailByApprovalNo = p => GETNEW('/approval/instances/detailByApprovalNo', p, 4)


//执行审批任务
export const dealApprovalNode = p => POST('/approval/instancetask/execution', p)

//批量执行审批任务
export const batchDealApprovalNode = p => POST('/approval/instancetask/batch/execution', p)

// 查看所有审批单
export const seeAllApproval = p => POST('/approval/instances/list', p)

//导出审批单
export const exportAllApproval = p => EXPORTNEW('/approval/instances/export', p, 5)
//导出暖心专列数据
export const exportTrainData = p => EXPORTNEW('/approval/return-home/export', p, 5)


//查询申请模板列表
export const getApprovalProcesses = p => GET('/approval/processes', p)

//获取审批统计页面的查询条件
export const getSearchConditions = p => GETNEW('/approval/query-config/get/{processId}', p)

//撤回审批
export const gwithdrawApproval = p => POSTNEW('/approval/deal/recall', p)
//获取审批统计页面的查询条件
export const getStatistical = p => GETNEW('/approval/statistical/get-all', p)
//师大暖心专列撤销
export const revokeTrainApproval = p => POSTNEW('/approval/return-home/cancelCarSeat', p)

//批量处理待办页面详情页面显示信息
export const getApprovalBatchInfo = p => POSTNEW('/approval/instances/batch/detail', p)

//审批通用分页查询（包含学生信息）
export const getApprovalGeneral = p => POSTNEW('/approval/instances/process-page', p)
//审批通用分页查询（包含学生信息）
export const getTicketApplyList = p => POSTNEW('/studentgrowthfiles/love-ticket/config/findPage', p)
//获取补助类型
export const getPlanClassId = p => POSTNEW('/studentgrowthfiles/commonType/createrRule', p)
//创建爱心车票
export const saveTicket = p => POSTNEW('/studentgrowthfiles/love-ticket/config/save', p)
//获取爱心车票的申请列表
export const getApplyTicketStudents = p => POSTNEW('/studentgrowthfiles/plan/apply/page/LOVE_TICKET', p)
//完成计划
export const finishPlan = p => POSTNEW('/studentgrowthfiles/plan/config/finish', p)
//爱心车票一键审批
export const oneClickApprovalloveTicket = p => POSTNEW('/studentgrowthfiles/love-ticket/approval/getApprovals', p)

// 上传图片
export const imageUpload = p => uploadingImg('/basic/aliyun-oos/upload-image/appraise-elct', p, 5)

//爱心车票公示
export const loveTicketFormula = p => POSTNEW('/studentgrowthfiles/plan/apply/publicity', p, 5)
//获取居住地列表
export const getResidenceList = p => GETNEW('/studentgrowthfiles/love-ticket/subsidies/list', p)
//新疆导出
export const exportLoveTickeApply = p => EXPORTNEW('/studentgrowthfiles/love-ticket/approval/export-xj', p, 5)
//特困导出
export const exportLoveTickeApplyTk = p => EXPORTNEW('/studentgrowthfiles/love-ticket/approval/export-tk', p, 5)
//获取爱心车票的申请列表
export const getJoinArmyAplyList = p => POSTNEW('/studentgrowthfiles/conscript-basic/findPage', p)

//创建入伍申请
export const saveJoinArmy = p => POSTNEW('/studentgrowthfiles/conscript-basic/save', p)
//获取入伍申请信息
export const getJoinArmyAplyInfo = p => GETNEW('/studentgrowthfiles/conscript-basic/getBasicInfo', p)
//获取入伍的申请列表
export const getJoinArmyStudents = p => POSTNEW('/studentgrowthfiles/plan/apply/page/CONSCRIPT', p)
//入伍导出
export const exportJoinApproval = p => EXPORTNEW('/studentgrowthfiles/conscript-apply/export', p, 5)
//获取入伍档案
export const getJoinArmyArchives = p => POSTNEW('/studentgrowthfiles/conscript-apply/page/CONSCRIPT', p)
// 走读档案分页查询         /studentgrowthfiles/plan/apply/page/DAY_STUDENT                  
export const getDayStudent = p => POSTNEW('/studentgrowthfiles/dayStudent-apply/page/DAY_STUDENT', p)
// 补充材料证明档案分页查询
export const getMaterial = p => POSTNEW('/studentgrowthfiles/dayStudent-apply/page/DAY_STUDENT_CONTRACT', p)
// 失效走读正分页查询
export const getDayCard = p => POSTNEW('/studentgrowthfiles/dayStudent-apply/page/DAY_STUDENT_RETURN_TO_SCHOOL', p)
// 校外住宿截止时间查询
export const getDayStudyDeadline = p => POSTNEW('/studentgrowthfiles/dayStudent-apply/page/DAY_STUDENT_APPLY_SCHOOL_TIME', p)
// 根据审批编号获取学生详情信息
export const getEditInfoStudent = p => GETNEW('/studentgrowthfiles/plan/apply/get/FRONT_PAGE/detail', p)
// 根据审批编号获取老师详情信息
export const getEditInfoTeacher = p => GETNEW('/studentgrowthfiles/plan/apply/get/AFTER_FILL/detail', p)
// 详情提交
export const submitTeacher = p => POSTNEW('/studentgrowthfiles/plan/apply/save/AFTER_FILL', p)
// 都读档案导出
export const exportDayStudent = p => EXPORT('/studentgrowthfiles/dayStudent-apply/export', p, 5)
// 详情提交
export const revocation = p => POSTNEW('/approval/deal/one-key-repeal', p)
// 走读审批详情(校外住宿)
export const lodgingApplicationDetaila = p => GETNEW('/studentgrowthfiles/dayStudent-apply/getInfoDetailDayStudent', p)
// 走读审批详情(材料过期审批)
export const lodgingApplicationDetailb = p => GETNEW('/studentgrowthfiles/dayStudent-apply/getInfoDetailRoom', p)
// 走读审批详情(申请返校)
export const lodgingApplicationDetailc = p => GETNEW('/studentgrowthfiles/dayStudent-apply/getInfoDetailReturnSchool', p)
// 走读审批详情(申请返校)
export const lodgingApplicationDetaild = p => GETNEW('/studentgrowthfiles/dayStudent-apply/getInfoUpdateTime', p)
// 走读权限配置
export const lodgingDispose = p => GETNEW('/studentgrowthfiles/plan/config/getfindByCode', p)
// 走读权限配置提交
export const submitLodgingDispose = p => POSTNEW('/studentgrowthfiles/plan/config/updateConfig', p)
// 入伍管理撤销
export const repealApplyId = p => POSTNEW('/studentgrowthfiles/plan/apply/repeal-applyId', p)
// 获取研究生校外走读结束时间
export const getLodgingModifyEndTime = p => GETNEW('/studentgrowthfiles/plan-apply/content-info/findContractByApplyAndCode', p)
// 提交研究生校外走读结束时间
export const submitLodgingModifyEndTime = p => POSTNEW('/studentgrowthfiles/plan-apply/content-info/updateValue', p)
// 走读锁定
export const lodginglockRow = p => POSTNEW('/approval/instancetask/updateTaskLock', p)


// WEBPACK FOOTER //
// ./src/api/modules/approval.js